import { useState, useEffect } from 'react';
import { apiClient } from '@services/api';
import { useHistory } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableFooter from '@material-ui/core/TableFooter';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import NumberFormat from 'react-number-format';
import Moment from 'react-moment';
import ChangeDate from './ChangeDate';
import ChangeDateTransfer from './ChangeDateTransfer';
import ChangeFlight from './ChangeFlight';
import { Link } from 'react-router-dom';
import Button from '@components/Button';
import Icon from '@material-ui/core/Icon';
import DeleteModal from '@components/DeleteModal'

const useIsMobile = () => {
  const [m, setM] = useState(window.innerWidth <= 768);
  useEffect(() => {
    const h = () => setM(window.innerWidth <= 768);
    window.addEventListener('resize', h);
    return () => window.removeEventListener('resize', h);
  }, []);
  return m;
};

const useStyles = makeStyles({
  tableContainer: {
    boxShadow: 'none',
  },
  table: {
    minWidth: 650,
  },
  borderNone: {
    border: 'none'
  }
});

const RequestTable = (props) => {
  const [changeDate, setChangeDate] = useState(false)
  const [changeDateTransfer, setChangeDateTransfer] = useState(false)
  const [date, setDate] = useState(null)
  const [modalFlight, setModalFlight] = useState(false)
  const [flight, setFlight] = useState(null)
  const [flightTime, setFlightTime] = useState(null)
  const [tourId, setTourId] = useState(null)
  const [index, setIndex] = useState(null)
  const classes = useStyles();
  const [disableModal, setDisableModal] = useState(false);
  const [idReservation, setIdReservation] = useState('');
  const [idxRow, setIdxRow] = useState('');
  const [discount, setDiscount] = useState(0);
  const [justify, setJustify] = useState('');
  const [toApprove, setToApprove] = useState(false);

  const history = useHistory();

  const handleModal = (row, idx) => {
    setIdReservation(row.id)
    setIdxRow(idx)
    setDisableModal(true)
  }

  const cancelReservation = () => {
    /* apiClient.httpInstance.post(`/reservations/${idReservation}/cancel`).then(response => {
      if (response.status === 200) {
        props.dataBudgets[idxRow].status = 0
        setDisableModal(false)
      }
    }); */
  }

  const HIGH_REGIONS   = ['santiago', 'atacama'];
  const DISC_PIX_HIGH  = 12; const DISC_PIX_LOW  = 7;
  const DISC_CARD_HIGH = 10; const DISC_CARD_LOW = 5;

  const getPayDiscPct = (row) => {
    const method = props.presale?.payment_method;
    if (!method || row.type === 'transfer') return 0;
    const region = (row.region_name || '').toLowerCase().trim();
    const isHigh = HIGH_REGIONS.includes(region);
    return method === 'pix'
      ? (isHigh ? DISC_PIX_HIGH : DISC_PIX_LOW)
      : (isHigh ? DISC_CARD_HIGH : DISC_CARD_LOW);
  };

  const getItemSub = (row) => {
    const a = Number(row.adults_total_amount || 0);
    const k = Number(row.kids_total_amount   || 0);
    return a + k || Number(row.total_amount || row.price || 0);
  };

  const getItemTotal = (row) => {
    const sub        = getItemSub(row);
    const manualDisc = Number(row.discount_total_sale || 0);
    const afterMan   = sub * (1 - manualDisc / 100);
    const payDisc    = getPayDiscPct(row);
    return Math.round(afterMan * (1 - payDisc / 100) * 100) / 100;
  };

  const discountTotal = () => {
    const total = props.dataBudgets.reduce((accumulator, currentValue) => accumulator + Number(currentValue.total_amount), 0)
    return total * discount / 100
  }

  const calcSubtotal = () => {
    return props.dataBudgets.reduce((s, row) => s + getItemSub(row), 0);
  }

  const calcTotal = () => {
    return props.dataBudgets.reduce((s, row) => s + getItemTotal(row), 0);
  }

  const isMobile = useIsMobile();
  const isPaid = props.presale?.payment_status === 'paid';
  const payMethod = props.presale?.payment_method;

  // Desconto gerencial — visível apenas no painel interno (consultor/gerente)
  const managerApproved = props.presale?.approval_status === 'approved' &&
    (props.presale?.approval_type === 'discount_pct' || props.presale?.approval_type === 'discount_value');
  const managerDiscountVal = (() => {
    if (!managerApproved) return 0;
    const sub = calcSubtotal();
    if (props.presale?.approval_type === 'discount_pct') {
      return Math.round(sub * parseFloat(props.presale.approval_manager_value || 0) / 100 * 100) / 100;
    }
    return Math.round(parseFloat(props.presale?.approval_manager_value || 0) * 100) / 100;
  });

  /* ── MOBILE VIEW ── */
  if (isMobile) {
    const sub     = calcSubtotal();
    const total   = calcTotal() - (isPaid ? 0 : managerDiscountVal());
    const fmtVal  = (v) => `${process.env.REACT_APP_CURRENCY} ${Number(v).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        {props.dataBudgets.map((row) => {
          const rowSub   = getItemSub(row);
          const rowTotal = getItemTotal(row);
          const rowDisc  = rowSub - rowTotal;
          return (
            <div key={row.id} style={{
              background: '#0f1c2e', borderRadius: 10, padding: '14px 16px',
              border: '1px solid #1e3a5a',
            }}>
              <div style={{ fontWeight: 700, fontSize: 15, color: '#e8f0fb', marginBottom: 4 }}>
                {row.tour_name || row.travel_name}
              </div>
              {row.transfer_type && (
                <div style={{ color: '#8ba5c4', fontSize: 12, marginBottom: 8 }}>
                  {row.travel_name} ({row.transfer_type})
                </div>
              )}
              <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13, marginBottom: 4 }}>
                <span style={{ color: '#8ba5c4' }}>Passageiros</span>
                <span style={{ color: '#e8f0fb' }}>
                  {row.type === 'transfer' ? row.adults_total : parseInt(row.adults_total || 0) + parseInt(row.kids_total || 0)}
                </span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13, marginBottom: 4 }}>
                <span style={{ color: '#8ba5c4' }}>Subtotal</span>
                <span style={{ color: '#e8f0fb' }}>{fmtVal(rowSub.toFixed(2))}</span>
              </div>
              {isPaid && rowDisc > 0 && (
                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13, marginBottom: 4 }}>
                  <span style={{ color: '#8ba5c4' }}>Desconto {payMethod === 'pix' ? 'PIX' : 'Cartão'}</span>
                  <span style={{ color: '#22c55e' }}>− {fmtVal(rowDisc.toFixed(2))}</span>
                </div>
              )}
              <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 14, fontWeight: 700, paddingTop: 8, borderTop: '1px solid #1e3a5a', marginTop: 6 }}>
                <span style={{ color: '#8ba5c4' }}>{isPaid ? 'Valor pago' : 'Valor'}</span>
                <span style={{ color: isPaid ? '#22c55e' : '#e8f0fb' }}>{fmtVal(rowTotal.toFixed(2))}</span>
              </div>
            </div>
          );
        })}

        {/* Totais */}
        <div style={{ background: '#172B4D', borderRadius: 10, padding: '14px 16px', border: '1px solid #1e3a5a' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13, marginBottom: 6 }}>
            <span style={{ color: '#8ba5c4' }}>Subtotal</span>
            <span style={{ color: '#e8f0fb' }}>{fmtVal(sub.toFixed(2))}</span>
          </div>
          {isPaid && (
            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13, marginBottom: 6 }}>
              <span style={{ color: '#8ba5c4' }}>Desconto {payMethod === 'pix' ? 'PIX' : 'Cartão'}</span>
              <span style={{ color: '#22c55e' }}>− {fmtVal((calcSubtotal() - calcTotal()).toFixed(2))}</span>
            </div>
          )}
          {managerApproved && (
            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13, marginBottom: 6 }}>
              <span style={{ color: '#f59e0b' }}>★ Desconto gerencial</span>
              <span style={{ color: '#f59e0b' }}>− {fmtVal(managerDiscountVal().toFixed(2))}</span>
            </div>
          )}
          <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 15, fontWeight: 700, paddingTop: 8, borderTop: '1px solid #1e3a5a' }}>
            <span style={{ color: isPaid ? '#22c55e' : '#e8f0fb' }}>{isPaid ? '✅ Valor pago' : 'Total'}</span>
            <span style={{ color: isPaid ? '#22c55e' : '#e8f0fb' }}>{fmtVal(total.toFixed(2))}</span>
          </div>
        </div>
      </div>
    );
  }

  return <>
    <TableContainer className={classes.tableContainer} component={Paper}>
      <Table className={classes.table}>
        <TableHead>
          <TableRow>
            <TableCell className="font-bold leading-5 text-blue border-0">Minhas reservas</TableCell>
            <TableCell className="font-bold leading-5 text-blue border-0">Passageiros</TableCell>
            <TableCell className="font-bold leading-5 text-blue border-0">Subtotal</TableCell>
            {isPaid && <TableCell className="font-bold leading-5 text-blue border-0">Desconto {payMethod === 'pix' ? 'PIX' : 'Cartão'}</TableCell>}
            <TableCell className="font-bold leading-5 text-blue border-0">{isPaid ? 'Valor pago' : 'Valor'}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.dataBudgets.map((row, idx) => {
            const sub      = getItemSub(row);
            const payDisc  = getPayDiscPct(row);
            const itemTotal = getItemTotal(row);
            const discVal  = Math.round((sub - itemTotal) * 100) / 100;
            return (
            <TableRow key={row.id}>
              <TableCell className="leading-5 text-blue border-0" component="th" scope="row">
                <div className="flex items-center">
                  <div className="flex-auto space-y-3">
                    <div className="font-medium text-lg">{row.tour_name || row.travel_name}</div>
                    <div>
                      {row.status === 0 ? <Icon className="mr-1 text-red-500" fontSize="small">block</Icon> : ''}
                      {row.travel_name} {row.transfer_type ? `(${row.transfer_type})` : null}
                    </div>
                  </div>
                </div>
              </TableCell>
              <TableCell className="leading-5 text-blue border-0" component="th" scope="row">
                {row.type === 'transfer' ? row.adults_total
                  : parseInt(row.adults_total || 0) + parseInt(row.kids_total || 0)}
              </TableCell>
              <TableCell className="leading-5 text-blue border-0" component="th" scope="row">
                <NumberFormat value={sub.toFixed(2)} displayType={'text'} decimalSeparator={","} decimalScale={2} fixedDecimalScale thousandSeparator={"."} isNumericString prefix={`${process.env.REACT_APP_CURRENCY} `} renderText={(v) => <span>{v}</span>} />
              </TableCell>
              {isPaid && (
                <TableCell className="leading-5 text-blue border-0" component="th" scope="row">
                  {payDisc > 0 ? (
                    <span style={{ color: '#22c55e' }}>
                      − <NumberFormat value={discVal.toFixed(2)} displayType={'text'} decimalSeparator={","} decimalScale={2} fixedDecimalScale thousandSeparator={"."} isNumericString prefix={`${process.env.REACT_APP_CURRENCY} `} renderText={(v) => <span>{v}</span>} />
                      <span style={{ fontSize: 11, marginLeft: 4, opacity: 0.7 }}>({payDisc}%)</span>
                    </span>
                  ) : '—'}
                </TableCell>
              )}
              <TableCell className="leading-5 text-blue border-0" component="th" scope="row">
                <NumberFormat value={itemTotal.toFixed(2)} displayType={'text'} decimalSeparator={","} decimalScale={2} fixedDecimalScale thousandSeparator={"."} isNumericString prefix={`${process.env.REACT_APP_CURRENCY} `} renderText={(v) => <span style={{ fontWeight: isPaid ? 700 : 400 }}>{v}</span>} />
              </TableCell>
              {props.isEditing && <TableCell className="leading-5 text-blue border-0" component="th" scope="row">
                {row.status !== 0 ? <><Button
                  textcolor="red"
                  padding="4px"
                  width="50"
                  variant="outlined"
                  bgColor="transparent"
                  onClick={() => handleModal(row, idx)}
                >
                  X
                </Button>
                </>
                  : ''}
              </TableCell>
              }
              {row.type === 'tour' && <ChangeDate
                type={row.type}
                open={changeDate}
                close={() => setChangeDate(false)}
                setDate={props.changeDate}
                date={date}
                idx={index}
                tourId={tourId}
                {...props}
              />}
              {row.type === 'transfer' && <ChangeDateTransfer
                type={row.type}
                open={changeDateTransfer}
                close={() => setChangeDateTransfer(false)}
                setDate={props.changeDate}
                date={date}
                idx={index}
                tourId={tourId}
                {...props}
              />}
              <ChangeFlight
                type={row.type}
                open={modalFlight}
                close={() => setModalFlight(false)}
                setFlight={props.changeFlight}
                setFlightTime={props.changeFlightTime}
                flight={flight}
                flightTime={flightTime}
                idx={index}
                tourId={tourId}
                {...props}
              />
            </TableRow>
          )})}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TableCell className="text-lg font-medium leading-5 border-0 text-blue">Subtotal</TableCell>
            <TableCell align="right" colSpan={isPaid ? 4 : 3} className="text-lg font-medium leading-5 border-0 text-blue">
              <NumberFormat value={calcSubtotal().toFixed(2)} displayType={'text'} decimalSeparator={","} decimalScale={2} fixedDecimalScale thousandSeparator={"."} isNumericString prefix={`${process.env.REACT_APP_CURRENCY} `} renderText={(value) => <span>{value}</span>} />
            </TableCell>
          </TableRow>
          {isPaid && (
            <TableRow>
              <TableCell className="text-lg font-medium leading-5 border-0 text-blue">Desconto {payMethod === 'pix' ? 'PIX' : 'Cartão'}</TableCell>
              <TableCell align="right" colSpan={4} className="text-lg font-medium leading-5 border-0" style={{ color: '#22c55e' }}>
                − <NumberFormat value={(calcSubtotal() - calcTotal()).toFixed(2)} displayType={'text'} decimalSeparator={","} decimalScale={2} fixedDecimalScale thousandSeparator={"."} isNumericString prefix={`${process.env.REACT_APP_CURRENCY} `} renderText={(value) => <span>{value}</span>} />
              </TableCell>
            </TableRow>
          )}
          {!isPaid && props?.dataBudgets[0]?.justify_discount && (
            <TableRow>
              <TableCell className="text-lg font-medium leading-5 border-0 text-blue">Justificativa</TableCell>
              <TableCell align="right" colSpan={3} className="text-lg font-medium leading-5 border-0 text-blue">{props?.dataBudgets[0]?.justify_discount}</TableCell>
            </TableRow>
          )}
          {managerApproved && (
            <TableRow>
              <TableCell className="text-lg font-medium leading-5 border-0" style={{ color: '#f59e0b' }}>★ Desconto gerencial</TableCell>
              <TableCell align="right" colSpan={isPaid ? 4 : 3} className="text-lg font-medium leading-5 border-0" style={{ color: '#f59e0b' }}>
                − <NumberFormat value={managerDiscountVal().toFixed(2)} displayType={'text'} decimalSeparator={","} decimalScale={2} fixedDecimalScale thousandSeparator={"."} isNumericString prefix={`${process.env.REACT_APP_CURRENCY} `} renderText={(v) => <span>{v}</span>} />
              </TableCell>
            </TableRow>
          )}
          <TableRow>
            <TableCell className="text-lg font-bold leading-5 border-0 text-blue">{isPaid ? '✅ Valor pago' : 'Total'}</TableCell>
            <TableCell align="right" colSpan={isPaid ? 4 : 3} className="text-lg font-bold leading-5 border-0" style={{ color: isPaid ? '#22c55e' : undefined }}>
              <NumberFormat
                value={(calcTotal() - (isPaid ? 0 : managerDiscountVal())).toFixed(2)}
                displayType={'text'}
                decimalSeparator={","}
                decimalScale={2}
                fixedDecimalScale={true}
                decimalPrecision={2}
                thousandSeparator={"."}
                isNumericString
                prefix={`${process.env.REACT_APP_CURRENCY} `}
                renderText={(value) => <span>{value}</span>}
              />
            </TableCell>
          </TableRow>
        </TableFooter>
      </Table>
      <DeleteModal
        open={disableModal}
        close={() => setDisableModal(false)}
        delete={() => cancelReservation()}
        title="Cancelar orçamento?"
        description="Você quer mesmo cancelar esse orçamento? Essa ação é irreversível."
      />
    </TableContainer>
  </>
}

export default RequestTable;
